export default "__VITE_ASSET__c6Q555tW__"